import ContentBlock from 'components/content-block';
import {
  Heading,
  Image,
  ImageGrid,
  Stack,
  StripeListItem,
  Text,
} from 'components/ui';
import { FC } from 'react';
import { Theme } from 'styles/theme';
import { urlForImage } from 'utils/sanity';

export interface SizesProps {
  module: Sanity.Schema.Sizes;
}

export const Sizes: FC<SizesProps> = ({ module }) => {
  const imageUrl = urlForImage(module.image).width(1024).url();
  const colors: (keyof Theme['colors'])[] = ['green', 'yellow', 'pink100'];

  return (
    <ContentBlock>
      <Stack space={{ initial: 2, large: 4, xLarge: 6 }}>
        {module.title && <Heading level='h2'>{module.title}</Heading>}
        {module.image && imageUrl && (
          <ImageGrid>
            <Image
              src={imageUrl}
              alt={module.title}
              layout='fill'
              objectFit='contain'
            />
          </ImageGrid>
        )}
      </Stack>
      {module.sizes && (
        <Stack space={{ initial: 4, large: 6, xLarge: 8 }} as='ul'>
          {module.sizes.map((size, index) => (
            <StripeListItem borderColor={colors[index]} key={size._key}>
              <Stack space={1}>
                {size.title && <Heading level='h4'>{size.title}</Heading>}
                {size.description && <Text>{size.description}</Text>}
                <Text fontWeight='bold'>
                  Size: {size.size} <br />
                  {size.price}
                </Text>
              </Stack>
            </StripeListItem>
          ))}
        </Stack>
      )}
    </ContentBlock>
  );
};
